@include host-component-properties;

:host * {
  font-weight: var(--paf-global-font-weight-bold);
}

.paf-result-time__delay {
  margin: 0;
  color: var(--paf-global-post-error);

  @include forced-colors {
    color: Highlight;
  }
}
